'use client';

import { RtItem } from '@dpa/react-item';
import { NAVIGATION_BUTTON_NAME } from '@portals/hc-rich-editor';
import { NavigationButton } from '../navigation-button';

type TProps = {
  text: string;
  isActive: boolean;
  isDesktop: boolean;
  element?: HTMLElement;
  onNavigate: (element?: HTMLElement) => void;
};

export const NavigationItem = ({
  text,
  isActive,
  isDesktop,
  element,
  onNavigate,
}: TProps) => {
  const handleClick = () => {
    const url = element
      ? `#${encodeURIComponent(element.id)}`
      : `${window.location.pathname}${window.location.search}`;

    window.history.replaceState(window.history.state, '', url);

    if (element) {
      element.scrollIntoView({ block: 'start', behavior: 'instant' });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
    onNavigate(element);
  };

  return (
    <RtItem
      aria-current={isActive ? 'location' : undefined}
      as={NavigationButton}
      cursor="pointer"
      data-name={NAVIGATION_BUTTON_NAME}
      label={text}
      labelLineClamp={0}
      modifier={isDesktop && isActive ? 'base' : 'filling'}
      onClick={handleClick}
      size="lg"
      use="cloudy"
      variant="normal"
      width="fill"
      isSurfaceStatic
    />
  );
};
